import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDrawerMode, MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { SliderConfiguration } from '../../../core/models/sliderConfiguration.model';
import { LoaderService } from '../../services/loader.service';

const STICKY_MENU_WIDTH = 55;

@Component({
  selector: 'anms-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  standalone: false
})
export class SliderComponent implements OnInit {

  public formWidth = '0px';
  public formMode: MatDrawerMode = 'over';
  public formChangesubscription!: Subscription;
  public formClosesubscription!: Subscription;
  public IsSilderReadOnly: boolean = false;
  public isFormOnHold = false;
  public isPinned: boolean = false;
  public isDirty: boolean = false;
  public leftMargin = 0;
  @ViewChild('sliderContent', { static: true, read: ViewContainerRef })
  public viewContainerRef!: ViewContainerRef;
  @ViewChild('slider') private slider!: MatSidenav;

  constructor(
    private loader: LoaderService
  ) { }

  ngOnInit(): void {
    this.formChangesubscription = this.loader
      .onComponentAdd()
      .subscribe((sliderConfig: SliderConfiguration) => {
        this.displayDrawer(sliderConfig.Width);
        this.IsSilderReadOnly = sliderConfig.IsSilderReadOnly;
      });
    this.formClosesubscription = this.loader
      .onFormClose()
      .subscribe(() => this.closeForm());
    this.loader.setRootViewContainerRef(this.viewContainerRef);
  }
  
  /**This method is handle Slider Window display When escape key is used on Slider */
  public onEscape(): void {
    this.updateSliderDisplay();
  }

  /** Method to open Slider Window on Click of form hold icon */
  public onHoldForm(): void {
    this.slider.open();
    this.isFormOnHold = false;
    if (this.isPinned) {
      this.isDirty = true;
      this.leftMargin = STICKY_MENU_WIDTH;
    }
  }

  /** Method to close Slider window */
  private closeForm(): void {
    this.slider.close();
    this.isFormOnHold = false;
  }

  /** Method to open Slider window */
  private displayDrawer(width: any): void {
    if (width.toString().includes('%')) {
      this.formWidth = width;
    } else {
      this.formWidth = width + 'px';
    }
    this.slider.open();
    this.isFormOnHold = false;
    if (this.isPinned) {
      this.isDirty = true;
      this.leftMargin = STICKY_MENU_WIDTH;
    }
  }

  private updateSliderDisplay(): void {
    if (this.IsSilderReadOnly) {
      this.closeForm();
      this.isFormOnHold = false;
    } else {
      if (this.loader.isSliderEdited() || this.loader.IsDataEdited()) {
        this.isFormOnHold = true;
      } else {
        this.closeForm();
        this.isFormOnHold = false;
      }
    }
  }
}
